import { Component, OnInit, Input } from "@angular/core";
import { MenuService } from "../services/menu/menu.service";
import { MenuStore } from "../store/menu/menu.store";
import { LocationsService } from "../services/locations/locations.service";
import { OrderService } from "../services/order/order.service";
import * as $ from "jquery";

import menuCategorySections from "./category-data/category-data";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"]
})
export class MenuComponent implements OnInit {
  // Menu
  public menuCategories;
  public menu;
  public menuResult;
  public filteredMenu;

  // Locations
  public locations;
  public locationID;
  public chooseLocations: boolean = true;
  public locationsLoading: boolean = true;
  public activeLocation;

  // Active vars
  public activeOrder: any;
  public currentCat;
  public menuIsActive: boolean = false;
  public addToOrderIsActive: boolean = false;

  public newHeader: boolean = false;
  public menuLoading: boolean = false;

  //Time Variables
  public allowBrunchOrdering: boolean = false;
  public allowLunchSpecialsOrdering: boolean = false;

  public itemModifiers;

  // Static data for the menu category sections.

  public menuCategorySections = menuCategorySections;

  public itemDescriptionBg = "./assets/menu/item-description-bg.png";
  public headlineBottomBorder = "./assets/menu/headline-bottom-border.svg";

  constructor(
    private menuService: MenuService,
    private _locationsService: LocationsService,
    private _menuStore: MenuStore,
    private _orderService: OrderService
  ) {}

  ngOnInit() {
    // Get the location ID
    this._orderService.locationID.subscribe(
      result => {
        this.locationID = result;
      },
      error => {
        console.log("could not get location");
      }
    );
    // Get the menu locations
    this.menuService.getMenuLocations().subscribe(
      result => {
        this.locations = result;
        setTimeout(() => {
          // Animate the underline on the locations list
          $(".locations-list")
            .find("li")
            .addClass("animate");
        }, 300);
      },
      error => {
        console.log("could not get the menu locations");
      },
      () => {
        this._menuStore.getMenu().subscribe(
          result => {
            this.menuResult = result;
            this.menu = result;
            this.locationsLoading = false;
            console.log("menu result observable", this.menuResult);
          },
          error => {
            console.log("could not get the menu");
          }
        );
      }
    );
    this._checkTime();
  }

  /**
   * Checks the time to see if the order button should be displated for
   * the lunch specials and or brunch on sundays
   * @param {Event} Object
   */
  private _checkTime() {
    // Get some date values to use on the menu
    let date = new Date();
    const currentDate = date.getDate();
    const currentDay = date.getDate();
    const currentHour = date.getHours();

    // If the day is Sunday and time is between 10 and 2 allow Brunch Ordering.
    if (currentDay === 0 && currentHour >= 10 && currentHour <= 14) {
      this.allowBrunchOrdering = true;
    }

    // If the day is a weekday and time between 11 and 4 allow lunch specials.
    if (currentDay !== 0 && currentDay !== 6 && currentHour >= 11 && currentHour <= 15) {
      this.allowLunchSpecialsOrdering = true;
    }
    // console.log('current Date', currentDate);
  }

  /**
   * Filter Menu Function takes an event and filters the current menu
   * based on the category that was selected.
   * @param {Event} Object
   */
  public filterMenu(event) {
    if (event.menuCategory !== "ALL") {
      this.menu = this.menuResult.filter(menuItem => {
        if (menuItem.category === event.menuCategory) {
          return menuItem;
        }
      });
    } else {
      this.menu = this.menuResult;
    }
  }

  /**
   * Chosen Location Runs when a click event happens on the menu sidebar.
   * @param {Event} Object
   */
  public chosenLocation(event) {
    if (typeof event.locationName === "string") {
      this.chooseLocations = false;
      this.menuIsActive = true;
    }
    if (typeof event.menuLoading === "boolean") {
      this.menuLoading = event.menuLoading;
    }
    if (typeof event.chooseLocations === "boolean") {
      this.chooseLocations = event.chooseLocations;
    }
  }

  /**
   * Choose Location runs when a click event happens on the menu component
   * @param {locationID} String
   * @param {locationName} String
   */
  public chooseLocation(locationID, locationName) {
    this.activeLocation = locationName;
    this._orderService.locationID.next(locationID);
    if (typeof this.activeLocation == "string") {
      this.chooseLocations = false;
      this.menuIsActive = true;
    }
  }

  /**
   * Activates the add to order component and sets the active item
   * which is then passed along to the add to order component
   * @param {item} Object
   */
  public orderItem(item) {
    this.addToOrderIsActive = true;
    this.activeOrder = item;
  }

  /**
   * Closes the add to order component.
   * @param {event} Object
   */
  public closeOrder(event) {
    this.addToOrderIsActive = event.addToOrderIsActive;
  }

  /**
   * Runs when the menu is looping through the menu items
   * if the menu item has a new category it renders the category header
   * with the new image, title and caption, and then continues rendering
   * the menu items for the specific category.
   * @param {category} String
   * @returns Boolean
   */
  public checkForNewCategoryHeader(category) {
    let itemCat = category;
    if (itemCat !== this.currentCat) {
      this.currentCat = itemCat;
      return true;
    } else {
      return false;
    }
  }

  /**
   * Runs during the rendering of the menu items.
   * if the items category are BRUNCH or LUNCH SPECIALS then we will
   * check if the time matches the available time for these items to be ordered.
   * @param {category} String
   * @returns Boolean
   */
  public checkIfOrderingIsAvailable(category) {
    if (category === "BRUNCH" && !this.allowBrunchOrdering) {
      return false;
    } else if (category === "LUNCH SPECIALS" && !this.allowLunchSpecialsOrdering) {
      return false;
    } else {
      // Everything else....
      return true;
    }
  }

  /**
   * Gets the menu caption for the header when the template
   * renders a new category header
   * @param {category} String
   */
  public getCategoryHeaderCaption(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].itemDesc;
  }

  public getCategoryHeaderTitle(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].title;
  }

  /**
   * Gets the menu caption background for the header when the template
   * renders a new category header
   * @param {category} String
   */
  public getCategoryHeaderCaptionBackground(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].descriptionBackground;
  }

  /**
   * Gets the menu caption color for the header when the template
   * renders a new category header
   * @param {category} String
   */
  public getCategoryHeaderCaptionColor(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].color;
  }

  /**
   * Gets the category image for the header when the template
   * renders a new category header
   * @param {category} String
   */
  public getCategoryHeaderImage(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].image;
  }

  /**
   * Gets the category subtitle for the header when the template
   * renders a new category header
   * @param {category} String
   */
  public getCategoryHeaderSubTitle(category) {
    let categorySection: any = this.menuCategorySections.filter(categorySection => {
      if (categorySection.category === category) {
        return categorySection;
      }
    });
    return categorySection[0].subTitle;
  }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts